import { useState, useContext } from 'react';
import DebugInfoContext from '../context/DebugContext';
import searchIcon from '../assets/search.svg'
import menuIcon from '../assets/menu.svg'
// import closeIcon from '../assets/close.svg'

const SearchBar = () => {
    const [searchedId, setSearchedId] = useState('');
    const [showInput, setShowInput] = useState(false); // State to control input box visibility
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { setId } = useContext(DebugInfoContext);

    const setUserInput = (e) => {
        setSearchedId(e?.target?.value);
    };

    const handleSearch = () => {
        // Split the string into an array of IDs using commas
        const arrayOfIds = searchedId?.trim()?.replace(/[-_ ]/g, '');

        setId([arrayOfIds]);
    };

    const handleKeyDown  = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const toggleInput = () => {
        setShowInput(!showInput); // Toggle input box visibility on icon click
    };


    const showMenu = async () => {
        setIsMenuOpen(!isMenuOpen);
    }
    return (
        <>
            <div className='relative flex flex-row items-center gap-2'>
                <img
                    onClick={toggleInput}
                    className="w-5 h-5 2xl:w-8 2xl:h-6 cursor-pointer md:cursor-pointer"
                    src={searchIcon}
                    alt="Search"
                />
                <input
                    className={`w-48 md:w-[22vw] md:block text-[12px] md:text-[14px] 2xl:text-base ${showInput ? 'block' : 'hidden'} focus:outline-none placeholder:text-xs 2xl:placeholder:text-sm placeholder:text-placeholder text-primaryText `}
                    placeholder='Enter Bless ID or Mac Id or Install Id or QR code'
                    type='search'
                    value={searchedId}
                    onChange={setUserInput}
                    onKeyDown={handleKeyDown}
                    style={{ transition: 'width 0.3s ease-in-out' }}
                />
                <img
                    onClick={showMenu}
                    className=" md:hidden w-5 h-5 2xl:w-8 2xl:h-6 cursor-pointer"
                    src={menuIcon}
                    alt="menu"
                />
            </div>
        </>
    );
};

export default SearchBar;
